import {Brand, CTA, Navbar, Feature } from './Components';
import {Blog,Footer,Header,Possibility,WhatGPT3} from './Containers'

function App() {
  return(
    
    <div>
      <div>
        <Navbar/>
        <Header/>
        <Feature/>
      </div>
      <Brand/>
      <WhatGPT3/>
      <Possibility/>
      <CTA/>
      <Blog/>
      <Footer/>
    </div>
  )
}
export default App;








// import About from "./About";
// import Analytics from "./Analytics";
// import Container from "./Container";
// import Footer from "./Footer";
// import Navbar from "./Navbar";
// import Notify from "./Notify";


// function App() {
//   return (
//     <div>
//       <Navbar/>
//       <About/>
//       <Analytics/>
//       <Notify/>
//       <Container/>
//       <Footer/>
    
//     </div>
//   );
// }

// export default App;
